// extracted by mini-css-extract-plugin
module.exports = {"error":"index-module__error___2Wj61","warning":"index-module__warning___1mop4","errorWrapper":"index-module__errorWrapper___TizZh"};